import React from "react";
import styled from "styled-components";

interface PageHeaderProps {
  title: string;
  description?: string;
  backgroundImage: string;
  height?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  backgroundImage,
  height = "60vh",
}) => {
  return (
    <HeaderWrapper backgroundImage={backgroundImage} height={height}>
      <Overlay />
      <Content data-aos="fade-up">
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </Content>
    </HeaderWrapper>
  );
};

export default PageHeader;

const HeaderWrapper = styled.section<{
  backgroundImage: string;
  height: string;
}>`
  width: 100%;
  height: ${(props) => props.height};
  background-image: url(${(props) => props.backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  /* PARALLAX EFFECT */
  background-attachment: fixed;

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  /* prevent jitter on mobile devices */
  @media (max-width: 768px) {
    background-attachment: scroll;
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
`;

const Content = styled.div`
  position: relative;
  text-align: center;
  color: white;
  max-width: 800px;
  padding: 0 20px;

  h1 {
    font-size: 2.8rem;
    margin-bottom: 10px;
    font-weight: 700;
  }

  p {
    font-size: 1.1rem;
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2rem;
    }
    p {
      font-size: 1rem;
    }
  }
`;
